import "./styles.scss";

interface FullScreenContentProps {
  children: React.ReactNode;
}

export const FullScreenContent = ({ children }: FullScreenContentProps) => (
  <div className="react-layout-fullscreen-content">
    <div className="react-layout-fullscreen-wrapper">{children}</div>
  </div>
);
